import { render, staticRenderFns } from "./nav-dropdown-trigger.vue?vue&type=template&id=5821d93b&"
import script from "./nav-dropdown-trigger.vue?vue&type=script&lang=js&"
export * from "./nav-dropdown-trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports